import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import NewsletterWidget from "../components/newsletter-widget"

const CategoryPage = ({ data }) => {
  const posts = data.wp.posts.edges
  return (
    <Layout className="blog-page" onlyFooter old>
      <SEO title="Blog" />
      <div className="flex container">
        <div className="left-main text-blue">
          <div className="container">
            <div className="filters">
              {[
                "Customer Stories",
                "News",
                "Media",
                "Education",
                "Product Updates",
              ].map((v, i) => {
                const path = `/blog/${v.toLowerCase().replace(" ", "-")}`
                let urlPath = ""

                if (typeof window !== "undefined") {
                  urlPath = window.location.pathname
                }

                return (
                  <Link
                    key={i}
                    to={path}
                    className={urlPath === path ? "active" : ""}
                  >
                    {v}
                  </Link>
                )
              })}
              <Link to="/blog">Latest posts</Link>
            </div>

            <h1 className="text-left page-title">Aider Blog</h1>
            <h2 className="text-left page-subtitle">
              Smart tips for growing buisinesses
            </h2>

            <div className="articles">
              {posts.map((v, i) => (
                <Link key={i} to={v.node.uri}>
                  <div className="single-article">
                    <div
                      style={{
                        backgroundImage: `url(${v.node.featuredImage.node.sourceUrl})`,
                      }}
                      className="thumbnail"
                    ></div>
                    <div className="text">
                      <h3>{v.node.title}</h3>
                      <p className="date">December 18, 2019</p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
        <div className="sidebar">
          <NewsletterWidget />
        </div>
      </div>
    </Layout>
  )
}
export default CategoryPage

export const query = graphql`
  query($id: [ID]) {
    wp {
      posts(where: { categoryIn: $id }) {
        edges {
          node {
            uri
            featuredImage {
              node {
                sourceUrl
              }
            }
            title
          }
        }
      }
    }
  }
`
